import {
  Box, Image, ListItem, Text,
} from '@domain-group/suit-theme'

import useCampaignComparable from '@hooks/useCampaignComparable'

import type { CampaignComparableModel } from '@models/types'

import ManuallyAddComparableIcon from '../../assets/manually_add_comparables.svg'

interface ManuallyAddComparableProps {
  campaignComparable: CampaignComparableModel,
}

const ManuallyAddComparable = (props: ManuallyAddComparableProps) => {
  const { campaignComparable } = props

  const {
    callbacks: {
      createOrEditCampaignComparable,
    },
  } = useCampaignComparable(campaignComparable)

  return (
    <ListItem
      borderColor="lineColor"
      boxProps={{
        alignItems: 'center',
        border: '1px solid',
        borderRadius: 5,
        marginTop: 'large',
        padding: 'large',
      }}
      onClick={() => createOrEditCampaignComparable()}
      forceBottomBorder
      showAngleIcon
    >
      <Image backgroundSize="contain" url={ManuallyAddComparableIcon} width={40} height={40} />

      <Box flexDirection="column" marginLeft="large">
        <Text>Manually Add Comparables</Text>

        <Text color="bodyFontLightColor" fontSize="xsmall" marginTop="small">Add a custom property yourself</Text>
      </Box>
    </ListItem>
  )
}

export default ManuallyAddComparable
